
import heartIcon from "../assets/images/hearit-icon.svg";
import matchIcon from "../assets/images/matchit-icon.svg";

function QuizSelector({setPanel}) {
    return (
        <div className={"quiz-selector"}>
            <h1>QUIZ</h1>
            <h2>Select a quiz type</h2>
            <div>
                <button onClick={() => setPanel("hear-it")} className="heartIcon"><img src={heartIcon} alt={"heart Icon"} /><span>HEAR IT</span> Listen to the phrases and pick the correct meaning.</button>
                <button onClick={() => setPanel("match-it")}><img src={matchIcon} alt={"Panda quiz logo"} /><span>MATCH IT</span> Match the phrases with their correct english meaning.</button>
            </div>
        </div>
    )
}

export default QuizSelector
